import React from 'react'
import AppDevelopmentTypePage from './AppDevelopmentTypePage'
import { appDevelopmentTypeContent } from './appDevelopmentTypeContent'

const RealEstateAppDevelopment = () => <AppDevelopmentTypePage content={appDevelopmentTypeContent.realEstate} />

export default RealEstateAppDevelopment
